/** @format */
import { css } from 'styled-components';

import { theme } from '@toucan/client/global/theme';

/* eslint-disable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
export const styles = css`
    display: flex;
    align-items: center;
    column-gap: var(--layout-spacing-8);
    ${theme.typography.body_small}

    .author-credit__avatar {
        flex-shrink: 0;
        height: 2.4rem;
        width: 2.4rem;
        border-radius: var(--effects-radius-full);
        overflow: hidden;

        img {
            height: 100%;
            width: 100%;
            object-fit: cover;
        }
    }

    .author-credit__info {
        margin: 0;
    }

    .author-credit__date {
        display: block;
    }
`;
/* eslint-enable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
